import { computed } from 'mobx';

import { OtpEmail, OtpIdentifier } from '~api/RampPgApiSdk';
import {
    OTP_CHANGE_EMAIL_ADDRESS,
    OTP_FLOW,
    OTP_SWITCH_TO_SMS_VERIFICATION,
    OTP_TYPE_SMS,
    OtpType,
    PC_EMAIL_ADDRESS_VERIFIED_REQUEST_ID
} from '~constants/Constants';

import { IOtpViewController, OtpViewController } from './OtpViewController';

export class OtpEmailViewController extends OtpViewController {
    private identifier: OtpEmail;

    constructor(params: IOtpViewController) {
        super(params);
        // Get email from form store
        this.loadFromStore();
    }

    @computed
    public get data() {
        const { emailAddress } = this.identifier;

        return {
            ...super.data,
            sendToText: emailAddress,
            changeToTranslationKey: OTP_CHANGE_EMAIL_ADDRESS,
            switchToTranslationKey: OTP_SWITCH_TO_SMS_VERIFICATION
        };
    }

    @computed
    public get requestBase(): OtpIdentifier {
        return this.identifier;
    }

    public get switchToOtpType(): OtpType {
        return OTP_TYPE_SMS;
    }

    public saveRequestIdIntoUserStore(id: string): void {
        this.userFormStore.setFieldValue(PC_EMAIL_ADDRESS_VERIFIED_REQUEST_ID, id);
    }

    private loadFromStore = () => {
        const { flow } = this.userRepository.otpStore.data || {};

        const flowToEmailAddressesMap = {
            [OTP_FLOW.FRAUD]:
                this.userRepository?.accountSignInFormStore?.values?.accountIdentifier ?? '',
            [OTP_FLOW.RESET_PASSWORD]:
                this.userRepository?.signInWithOtpFormStore?.values?.emailAddress ?? '',
            [OTP_FLOW.SIGN_IN_WITH_OTP]:
                this.userRepository?.signInWithOtpFormStore?.values?.emailAddress ?? '',
            [OTP_FLOW.SIGN_UP]: this.userRepository?.userFormStore?.values?.pcEmailAddress ?? '',
            default: this.userFormStore.values?.pcEmailAddress ?? ''
        };

        this.identifier = {
            emailAddress:
                flowToEmailAddressesMap[flow as OTP_FLOW] ?? flowToEmailAddressesMap.default
        };
    };
}
